import { create } from 'zustand';
import type { WSConnectionStatus } from '@/types';
import { wsManager } from '@/api/websocket';

interface WsState {
  status: WSConnectionStatus;
  connect: (token: string) => void;
  disconnect: () => void;
}

export const useWsStore = create<WsState>((set) => {
  wsManager.onStatusChange((status) => set({ status }));

  return {
    status: 'disconnected',

    connect: (token: string) => {
      wsManager.connect(token);
    },

    disconnect: () => {
      wsManager.disconnect();
    },
  };
});
